function Footer() {
  return (
    <footer style={{ background: '#000', color: 'white', padding: '1rem 0', textAlign: 'center', borderTop: '1px solid rgba(255, 255, 255, 0.15)' }}>
      © 2026 | By <strong>Emanuel Soares</strong>
    </footer>
  );
}

export default Footer;